/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formSubmissionAnswerOutputDataSchema = z.object({
	answer: z.string().nullable(),
	optionId: z.string().nullable(),
	updatedAt: z.iso.datetime(),
})

export type FormSubmissionAnswerOutputDataSchema = z.infer<typeof formSubmissionAnswerOutputDataSchema>
